const findParent = ({
  element,
  attr
}) => {
  const findParentElementByAttribute = (el, attribute) => {
    if (!el || el.hasAttribute(attribute)) {
      return el;
    }
    return findParentElementByAttribute(el.parentElement, attribute);
  };
  const foundElement = findParentElementByAttribute(element, attr);
  return foundElement || element;
};
export {
  findParent
};
//# sourceMappingURL=findParent.js.map
